import { render, staticRenderFns } from "./proyectos-rsc.vue?vue&type=template&id=773280ef"
import script from "./proyectos-rsc.vue?vue&type=script&lang=js"
export * from "./proyectos-rsc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports